module.exports = __webpack_public_path__ + "static/img/10006 (5).5caf4de.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10006 (5).webp
// module id = Y3tT
// module chunks = 14